/**
 * Requirements decided by a caseworker's evaluation of evidence, not by a
 * fact: genuineness and subsistence of the relationship (E-ECP.2.6),
 * intention to live together permanently (E-ECP.2.10), and the adequacy of
 * accommodation (E-ECP.3.4).
 *
 * These are STATED and never scored (ADR-0022). A calculator cannot decide
 * them, and asking "is your relationship genuine?" only to echo the answer
 * back as MET would teach the user a tick they have not earned — worse than
 * saying nothing. The rule's own `plain_english` and evidence list carry what
 * the requirement is judged on; this predicate just refuses to render a
 * verdict.
 */
import type { EvaluatePredicate } from "./predicate.js";

export const assessed_by_caseworker: EvaluatePredicate = () => ({
  status: "ASSESSED_BY_CASEWORKER",
});
